import { useEffect, useRef, useState } from "react";

// 쪽 위 QR 자리에 심는 스피커(2026-10-18 대표). 종이책의 QR 처럼 누르면 본문을 처음부터 들려준다.
// 속도 조절은 두지 않는다. 다른 음원 단추(PassageAudioButton)와 같은 알림으로 한 번에 하나만 울린다.
const PLAY_EVENT = "passage-audio-play";

const SpeakerButton = ({ audioUrl, style }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  // 음원을 못 열면(지인에듀 이용권이 끝나면 404) 숨는다
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    const pauseIfOther = (event) => {
      if (audioRef.current && event.detail !== audioRef.current) audioRef.current.pause();
    };
    window.addEventListener(PLAY_EVENT, pauseIfOther);
    const audio = audioRef.current;
    return () => {
      window.removeEventListener(PLAY_EVENT, pauseIfOther);
      if (audio) audio.pause();
    };
  }, []);

  if (!audioUrl || isBroken) return null;

  const toggle = (event) => {
    event.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) audio.play().catch(() => setIsPlaying(false));
    else audio.pause();
  };

  return (
    <button
      type="button"
      className={`page-speaker${isPlaying ? " is-playing" : ""}`}
      style={style}
      onClick={toggle}
      aria-label={isPlaying ? "멈추기" : "본문 듣기"}
    >
      <audio
        ref={audioRef}
        src={audioUrl}
        preload="none"
        onPlay={() => {
          setIsPlaying(true);
          window.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: audioRef.current }));
        }}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onError={() => setIsBroken(true)}
      />
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {isPlaying ? (
          <path d="M9 6v12M15 6v12" />
        ) : (
          <>
            <path d="M4 9h4l5-4v14l-5-4H4z" />
            <path d="M16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12" />
          </>
        )}
      </svg>
    </button>
  );
};

export default SpeakerButton;
